'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getOwnPropertyDescriptor = require('babel-runtime/core-js/object/get-own-property-descriptor');

var _getOwnPropertyDescriptor2 = _interopRequireDefault(_getOwnPropertyDescriptor);

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _promise = require('babel-runtime/core-js/promise');

var _promise2 = _interopRequireDefault(_promise);

var _dec, _dec2, _dec3, _class, _desc, _value, _class2, _class3, _temp;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactHelmet = require('react-helmet');

var _reactHelmet2 = _interopRequireDefault(_reactHelmet);

var _reactRedux = require('react-redux');

var _contacts = require('redux/modules/contacts');

var contactsActions = _interopRequireWildcard(_contacts);

var _reduxConnect = require('redux-connect');

var _components = require('components');

var _ContactForm = require('./ContactForm');

var _ContactForm2 = _interopRequireDefault(_ContactForm);

var _reactI18next = require('react-i18next');

var _pagination = require('helpers/pagination');

var _asyncPromise = require('helpers/async-promise');

var _asyncPromise2 = _interopRequireDefault(_asyncPromise);

var _autobindDecorator = require('autobind-decorator');

var _autobindDecorator2 = _interopRequireDefault(_autobindDecorator);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) {
  var desc = {};
  Object['ke' + 'ys'](descriptor).forEach(function (key) {
    desc[key] = descriptor[key];
  });
  desc.enumerable = !!desc.enumerable;
  desc.configurable = !!desc.configurable;

  if ('value' in desc || desc.initializer) {
    desc.writable = true;
  }

  desc = decorators.slice().reverse().reduce(function (desc, decorator) {
    return decorator(target, property, desc) || desc;
  }, desc);

  if (context && desc.initializer !== void 0) {
    desc.value = desc.initializer ? desc.initializer.call(context) : void 0;
    desc.initializer = undefined;
  }

  if (desc.initializer === void 0) {
    Object['define' + 'Property'](target, property, desc);
    desc = null;
  }

  return desc;
}

var Contacts = (_dec = (0, _reduxConnect.asyncConnect)([{
  promise: function promise(_ref) {
    var _ref$store = _ref.store,
        dispatch = _ref$store.dispatch,
        getState = _ref$store.getState;

    var promises = [];
    promises.push(dispatch(contactsActions.loadContacts({ page: 1, limit: getState().contacts.contactsListLimit })).promise);
    promises.push(dispatch(contactsActions.loadGroups()).promise);
    return (0, _asyncPromise2.default)(_promise2.default.all(promises));
  }
}]), _dec2 = (0, _reactRedux.connect)(function (state) {
  return {
    contactsList: state.contacts.contactsListData.contacts,
    contactsListLimit: state.contacts.contactsListLimit,
    contactsCurrentPage: state.contacts.contactsListActionData.page,
    kw: state.contacts.kw
  };
}, (0, _extends3.default)({}, contactsActions)), _dec3 = (0, _reactI18next.translate)(['common']), _dec(_class = _dec2(_class = _dec3(_class = (_class2 = (_temp = _class3 = function (_Component) {
  (0, _inherits3.default)(Contacts, _Component);

  function Contacts() {
    (0, _classCallCheck3.default)(this, Contacts);
    return (0, _possibleConstructorReturn3.default)(this, (Contacts.__proto__ || (0, _getPrototypeOf2.default)(Contacts)).apply(this, arguments));
  }

  (0, _createClass3.default)(Contacts, [{
    key: 'reloadContactsPage',
    value: function reloadContactsPage() {
      var _props = this.props,
          loadContacts = _props.loadContacts,
          kw = _props.kw,
          contactsCurrentPage = _props.contactsCurrentPage,
          contactsList = _props.contactsList,
          contactsListLimit = _props.contactsListLimit;

      var page = (0, _pagination.getReloadPage)(contactsList, contactsCurrentPage);
      loadContacts({ page: page, limit: contactsListLimit, kw: kw });
    }
  }, {
    key: 'render',
    value: function render() {
      var _props2 = this.props,
          t = _props2.t,
          contactsListLimit = _props2.contactsListLimit;


      return _react2.default.createElement(
        'div',
        { className: 'page' },
        _react2.default.createElement(_reactHelmet2.default, { title: 'Contacts' }),
        _react2.default.createElement(
          'div',
          { className: 'container-fluid' },
          _react2.default.createElement(
            'h1',
            null,
            t('Contacts')
          ),
          _react2.default.createElement(
            'div',
            { className: 'row wide-border' },
            _react2.default.createElement(
              'div',
              { className: 'col-sm-60 col-md-30 col-md-push-30 margin-bottom-20' },
              _react2.default.createElement(_components.ManageLink, {
                className: 'section',
                link: '/contacts/groups',
                header: t('Manage groups'),
                text: t('Click here to create and manage your recipients groups')
              }),
              _react2.default.createElement(
                'h3',
                null,
                t('Create new contact')
              ),
              _react2.default.createElement(
                'div',
                null,
                _react2.default.createElement(
                  'h5',
                  null,
                  t('Option'),
                  ' 1'
                ),
                _react2.default.createElement(
                  'p',
                  { className: 'hint small' },
                  t('You can import recipients from csv file.')
                ),
                _react2.default.createElement(_components.ContactsImportButton, { onImport: this.reloadContactsPage })
              ),
              _react2.default.createElement(
                'div',
                { className: 'margin-top-20' },
                _react2.default.createElement(
                  'h5',
                  null,
                  t('Option'),
                  ' 2'
                ),
                _react2.default.createElement(
                  'div',
                  { className: 'hint small' },
                  t('Enter your contact manually using the form below.')
                ),
                _react2.default.createElement(_ContactForm2.default, { onAdd: this.reloadContactsPage })
              )
            ),
            _react2.default.createElement(
              'div',
              { className: 'col-sm-60 col-md-30 col-md-pull-30' },
              _react2.default.createElement(_components.ContactsList, { limit: contactsListLimit, onDelete: this.reloadContactsPage })
            )
          )
        )
      );
    }
  }]);
  return Contacts;
}(_react.Component), _class3.propTypes = {
  contactsCurrentPage: _propTypes2.default.number,
  contactsList: _propTypes2.default.array,
  contactsListLimit: _propTypes2.default.number,
  kw: _propTypes2.default.string,
  loadContacts: _propTypes2.default.func,
  t: _propTypes2.default.func.isRequired
}, _temp), (_applyDecoratedDescriptor(_class2.prototype, 'reloadContactsPage', [_autobindDecorator2.default], (0, _getOwnPropertyDescriptor2.default)(_class2.prototype, 'reloadContactsPage'), _class2.prototype)), _class2)) || _class) || _class) || _class);
exports.default = Contacts;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/containers/Contacts/Contacts/Contacts.js
// module id = 2149
// module chunks = 1